import styled from "styled-components";

export const DropdownSearchWrapper = styled.div`
  width: 100%;
`;

export const OptionWrapper = styled.div`
  .selected {
    .fui-Option__checkIcon {
      visibility: visible;
    }
  }
`;

export const ListboxWrapper = styled.div`
position: relative;
`;

export const SearchWrapper = styled.div`
  width: 100%;
  padding: 0px;
  border-bottom: 1px solid var(--colorNeutralStroke2);
  box-sizing: border-box;
`;

export const CheckboxWrapper = styled.div`
 padding-left: var(--spacingHorizontalS);
 padding-right: var(--spacingHorizontalS);
`;

export const TableVirtualizationWrapper = styled.div`
  padding: var(--spacingVerticalS) var(--spacingHorizontalM);
  .fui-TableHeader {
    .fui-TableRow {
      min-height: 44px;
    }
  }
  /* Prevent blurry rendering - avoid forced GPU layers */
  .scroll-bar-custom {
    will-change: auto !important; /* Let browser decide, avoid forced composite layers */
  }
  
  /* Keep elements crisp without GPU acceleration */
  .fui-TableRow {
    will-change: auto; /* Avoid transform optimizations that cause blur */
  }
  
  /* Only essential text rendering optimizations */
  .fui-TableCell {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .vir-custom {
    will-change: auto;
  }
`;
